import * as types from "./types";
import {
    getLeaveTypeListAxios,
    deleteLeaveTypeAxios,
    postLeaveTypeAxios,
    putLeaveTypeAxios,
    getLeaveTypeByIDAxios
} from "./services";

export async function getLeaveTypeListAction({ commit }) {
    commit(types.LOADING_LEAVETYPE, true);
    try {
        const { data } = await getLeaveTypeListAxios();
        commit(types.GET_LEAVETYPE_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVETYPE, false);
    }
}

export async function removeLeaveTypeAction({ commit }, payload) {
    commit(types.LOADING_LEAVETYPE, true);
    try {
        await deleteLeaveTypeAxios(payload);
        commit(types.REMOVE_LEAVETYPE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVETYPE, false);
    }
}

export async function addLeaveTypeAction({ commit }, payload) {
    commit(types.LOADING_LEAVETYPE, true);
    try {
        await postLeaveTypeAxios(payload);
        commit(types.ADD_LEAVETYPE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVETYPE, false);
    }
}

export async function updateLeaveTypeAction({ commit }, payload) {
    commit(types.LOADING_LEAVETYPE, true);
    try {
        await putLeaveTypeAxios(payload);
        commit(types.UPDATE_LEAVETYPE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVETYPE, false);
    }
}


export async function getLeaveTypeByIDAction({commit}, payload) {
    commit(types.LOADING_LEAVETYPE, true);
    try {
        
        const {data} = await getLeaveTypeByIDAxios(payload);
        commit(types.GET_LEAVETYPEBYID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVETYPE, false);
    }
   
}